import images from 'assets/images/images'
import { useEffect, useRef, useState } from 'react'
import { RiDeleteBin6Line } from 'react-icons/ri'
import { MdModeEditOutline } from 'react-icons/md'
import { useRequest } from 'hooks/useRequest'
import { useDispatch } from 'react-redux'
import {  updateAddressFunc, updateUserChoises, useEffectTrigger } from 'redux/features/general/generalSlice'
import { toast } from 'react-toastify'
import { stages } from 'utils/Constants'
import useTranslate from 'hooks/useTranslate'
//import AddressAddDrawer from './AddressAddDrawer';
//import Drawer from 'react-modern-drawer'

const AddressCard = ({ setRegisterState, forHome, item, setIsOpenDrawer, isOpenDrawer }) => {
	const [openEdit, setOpenEdit] = useState(false)
	const [request] = useRequest()
	const dispatch = useDispatch()
	const drRef = useRef(null)
	const {t} = useTranslate()

	useEffect(() => {
		/**
		 * Alert if clicked on outside of element
		 */
		function handleClickOutside(event) {
			if (drRef.current && !drRef.current.contains(event.target)) {
				setOpenEdit(false)
			}
		}
		// Bind the event listener
		document.addEventListener('mousedown', handleClickOutside)
		return () => {
			// Unbind the event listener on clean up
			document.removeEventListener('mousedown', handleClickOutside)
		}
	}, [drRef])


	const editFunc = () => {
		// buralara sonradan farklı seyler gelecek ...
		setOpenEdit(!openEdit)
	}

	const updateAddress = async (id) => {
		setIsOpenDrawer(!isOpenDrawer)

		await request(`/Profile/Addresses/${id}`, {
			method: 'GET',
		}).then((res) => {
			if (res) {
				dispatch(updateAddressFunc(res.data.result))
			}
		})
		setOpenEdit(!openEdit)
	}

	const deleteAddress = (id) => {
		request('/Profile/DeleteAddress', {
			method: 'POST',
			data: {
				id: id,
			},
		}).then((res) => {
			if (res) {
				dispatch(useEffectTrigger(2))
				toast.success(t('successfullToast',{name:t('address'),type:t('delete')}))
				setOpenEdit(false)
			}
		})
	}
	const continueWithThisAddress = () => {
		dispatch(updateUserChoises({ addressId: item?.id, text: 'Adres', neighbourhoodId: item?.neighbourhoodId, deliveryType: 2 }))
		//forHome && dispatch(homeAddressReChoice({ openStatus: openStatus(), step: 2 }))
		setRegisterState && setRegisterState(stages.STAGE_BRANCH)
	}
	return (
		<>
			<div className='addressCard'>
				<div>
					<div className='addressCard-name'>{item?.addressTitle}</div>
					<div className='addressCard-desc'>{item?.addressDescription}</div>
				</div>
				{forHome ? (
					<div className="d-flex align-items-center gap-3">
						<img onClick={() => editFunc(item?.id)} src={images.add2} alt='' />
						<img onClick={continueWithThisAddress} src={images.buttonS} alt='' />
					</div>
				) : (
					<img onClick={() => editFunc(item?.id)} src={images.add2} alt='' />
				)}

				{openEdit && (
					<div ref={drRef} className='addressCard-editDropdown'>
						<div onClick={() => updateAddress(item?.id)}>
							<MdModeEditOutline size={30} color='#96004B' /> {t('updateBtn')}
						</div>
						<div onClick={() => deleteAddress(item?.id)}>
							<RiDeleteBin6Line size={25} /> {t('removeBtn')}
						</div>
					</div>
				)}

				{item.btn && (
					<button className='addressCard-rightArrow'>
						<img src={item.btn} alt='' />
					</button>
				)}
			</div>
			{/* <Drawer
                    open={isOpenDrawer}
                    onClose={() => setIsOpenDrawer(!isOpenDrawer)}
                    direction='right'
                    className='addressAddDrawer'
                >
                    <AddressAddDrawer setIsOpenDrawer={setIsOpenDrawer} />
                </Drawer> */}
		</>
	)
}

export default AddressCard
